import React, { useEffect, useMemo, useState } from 'react';
import { designCatalogLink, extractDesignArticles, loadDesignCatalog } from '../../services/designCatalog';
import './DesignLayoutPreview.css';

function LayoutCard({ article, layout, status, retry }) {
    const [brokenImage, setBrokenImage] = useState(false);
    useEffect(() => setBrokenImage(false), [layout?.thumbnail]);
    const libraryUrl = designCatalogLink(article);
    return <article className="design-layout-preview" aria-label={`Макет ${article}`}>
        {layout?.thumbnail && !brokenImage ? <a className="design-layout-preview__visual" href={libraryUrl} target="_blank" rel="noopener noreferrer">
            <img src={layout.thumbnail} alt={`Превью ${article}: ${layout.title}`} loading="lazy" width="200" height="126" onError={() => setBrokenImage(true)} />
        </a> : null}
        <div className="design-layout-preview__info">
            <a className="design-layout-preview__title" href={libraryUrl} target="_blank" rel="noopener noreferrer">{article}{layout ? ` · ${layout.title}` : ''} ↗</a>
            {layout ? <>
                <span className="design-layout-preview__caption">Основа из библиотеки · {layout.category}</span>
                {(!layout.thumbnail || brokenImage) && <span className="design-layout-preview__caption">Превью недоступно</span>}
                <div className="design-layout-preview__files">
                    {layout.files.map((file, index) => <a key={`${file.url}-${index}`} href={file.url} target="_blank" rel="noopener noreferrer" title={file.name} aria-label={`Скачать ${article}: ${file.name}`}>{file.format} ↓</a>)}
                    {layout.folderUrl && <a href={layout.folderUrl} target="_blank" rel="noopener noreferrer">Папка с файлами ↗</a>}
                </div>
            </> : <span className="design-layout-preview__caption" role="status">
                {status === 'loading' ? 'Загружаем превью…' : status === 'error' ? <>Каталог временно недоступен. <button type="button" onClick={retry}>Повторить</button></> : 'Артикул не найден в текущем каталоге. Открыть поиск можно по ссылке выше.'}
            </span>}
        </div>
    </article>;
}

export default function DesignLayoutPreview({ text }) {
    const articleKey = useMemo(() => extractDesignArticles(text).join(','), [text]);
    const [state, setState] = useState({ status: 'loading', catalog: null });
    const [attempt, setAttempt] = useState(0);
    useEffect(() => {
        if (!articleKey) return undefined;
        let active = true;
        setState({ status: 'loading', catalog: null });
        loadDesignCatalog({ retry: attempt > 0 }).then(catalog => {
            if (active) setState({ status: 'ready', catalog });
        }).catch(() => {
            if (active) setState({ status: 'error', catalog: null });
        });
        return () => { active = false; };
    }, [articleKey, attempt]);
    if (!articleKey) return null;
    return <div className="design-layout-previews">
        {articleKey.split(',').map(article => <LayoutCard key={article} article={article} layout={state.catalog?.get(article)} status={state.status} retry={() => setAttempt(value => value + 1)} />)}
    </div>;
}
